<template>
  <div id="pageWrapper">
    <loading-notification
      v-if="!page"
      message="De pagina wordt geladen...">
    </loading-notification>

    <template v-else>
      <div class="columns">
        <div class="column">
          <page-header @download="download"></page-header>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <page-management v-if="auth && !isPublic"></page-management>
        </div>
      </div>

      <template v-if="gridMode">
        <page-grid
          :showContent="showContent"
          @showGeneralText="toggleGeneralText(!showGeneralText)">
        </page-grid>

        <div
          v-if="showGeneralText"
          class="columns">

          <page-general-text
            :pageId="page.id"
            :bundleId="page.bundle.id">
          </page-general-text>
        </div>
      </template>

      <div v-else class="columns">
        <div
          class="column"
          :class="{'is-one-quarter': showContent}">
          <page-tree @showGeneralText="toggleGeneralText(true)"></page-tree>
        </div>

        <page-general-text
          v-if="showGeneralText"
          :pageId="page.id"
          :bundleId="page.bundle.id">
        </page-general-text>

        <div v-if="showContent" class="column is-three-quarters">
          <page-content :path="path"></page-content>
        </div>
      </div>

      <template v-if="canEdit && page.orphans.length > 0">
        <hr>
        <page-orphans :path="path"></page-orphans>
      </template>
    </template>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import pagesMixin from '@/mixins/pages'
import PageTree from '@/components/pages/PageTree'
import PageGrid from '@/components/pages/PageGrid'
import PageHeader from '@/components/pages/PageHeader'
import PageContent from '@/components/pages/PageContent'
import PageOrphans from '@/components/pages/PageOrphans'
import PageManagement from '@/components/pages/PageManagement'
import PageGeneralText from '@/components/pages/PageGeneralText'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  name: 'Page',

  mixins: [
    authMixin,
    pagesMixin
  ],

  components: {
    PageTree,
    PageGrid,
    PageHeader,
    PageContent,
    PageOrphans,
    PageManagement,
    PageGeneralText,
    LoadingNotification
  },

  data () {
    return {
      path: [],
      text: '',
      showContent: false,
      showGeneralText: false
    }
  },

  created () {
    this.$store.commit('pages/SET_PUBLIC', this.$route.name === 'public-page')

    this.$store.dispatch('pages/load', this.$attrs)

    bus.$on('setPath', (payload) => {
      this.path = payload
    })

    bus.$on('closeContent', () => {
      this.showContent = false
      this.showGeneralText = false
      this.$store.commit('pageItems/SET_ITEM', null)
    })

    bus.$on('showContent', (payload) => {
      this.path = payload.path
      this.showContent = true
    })
  },

  beforeDestroy () {
    this.$store.commit('pages/RESET_PAGE')
  },

  computed: {
    ...mapGetters({
      auth: 'account/auth',
      page: 'pages/page',
      mode: 'pages/mode',
      isPublic: 'pages/isPublic',
      account: 'account/account',
      isAuthorised: 'users/isAuthorised'
    }),

    gridMode () {
      return this.mode === 'grid'
    },

    identifier () {
      return this.path.substring(0, this.path.lastIndexOf(':'))
    },

    nextColumn () {
      return this.page.columns[this.depth + 1]
    },

    canEdit () {
      return (this.isAdmin(this.account) || this.inScope(this.account, 14)) && this.isAuthorised
    }
  },

  watch: {

    showContent () {
      if (this.showContent) this.showGeneralText = false
    },

    showGeneralText () {
      if (this.showGeneralText) this.showContent = false
    }
  },

  methods: {
    download () {
      this.$store.dispatch('pageItems/download', this.page)
    },

    toggleGeneralText (state) {
      this.showGeneralText = state
    },

    isSelected (valueId) {
      if (this.selected === null) return false

      return this.selected.parents.includes(valueId)
    },

    getButtonClass (value) {
      if (this.isSelected(value.id)) return 'is-info'
      if (!value.children) return 'is-loading'

      return null
    }
  }
}
</script>
